import styled from "styled-components";

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const Checkbox = styled.input`
  width: 1.2rem;
  height: 1.2rem;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const CheckboxLabel = styled.label`
  font-weight: 500;
  color: #333;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const CheckboxDescription = styled.p`
  font-size: 0.8rem;
  color: #666;
  margin-top: 0.25rem;
`;
